import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaConsentDialogComponent } from './ga-consent-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    GaConsentDialogComponent
  ],
  imports: [
    // FlexLayoutModule,
    CommonModule,
    // MatIconModule,
    // MatDialogModule,
    MatButtonModule,
    // MatProgressSpinnerModule,
    // LoadingIndicatorModule,
    // FormsModule,
    // MatRadioModule
  ],
  exports: [
    GaConsentDialogComponent
  ]
})
export class GaConsentDialogModule { }
